<div class="upcoming-main-container" *ngIf="tabValue === 'upcoming'">
  <div class="no-today-booking" *ngIf="!upcomingOnly && !todaysBookings">
    <span class="no-today-booking-text">No Todays Booking</span>
  </div>
  <div class="today-container" *ngIf="!upcomingOnly && todaysBookings">
    <div class="header">
      <span class="header-title">Today’s Booking</span>
    </div>
    <mat-card class="booking-card" [ngStyle]="{'height': managerStatus.managerState?'280px':'258px'}">
      <div class="card-horizontal-header" *ngIf="managerStatus?.managerState">
        <span class="manager-status"  [style.color]="managerStatus.color">{{managerStatus?.managerState}}</span>
        <span class="manager-state">{{managerStatus.text}}</span>
      </div>
      <div class="displayFlex card-body-wrapper" [ngStyle]="{'border': managerStatus.managerState?'4px solid #E0E0E0':'none','background-color': managerStatus?.managerState?'#E0E0E0':'#E0E0E0'}">
        <div class="card-vertical-header">
          <div class='vertical-text-wrapper'>
            <span class="vertical-header-title">{{todaysBookings?.spotBookingType || '--'}}</span>
          </div>
        </div>
        <div class="card-body">
          <div class="schedule-container">
            <span class="schedule-text"><span class="schedule-date">{{getBookingDate(todaysBookings?.startTime?.split('
                ')[0])}}</span>
              <span mis-input-icon><img src="/assets/images/dot.svg" alt="" /></span>
              <span class="schedule-time">{{getBookingTime(todaysBookings)}}</span></span>
          </div>
          <div class="trip-detail-container">
            <div class="trip-info">
              <!-- <p class="car-info" *ngIf="todaysBookings?.cab">{{bookings[0]?.cab?.registration}} / {{todaysBookings?.vehicleMake
                || todaysBookings?.vehicleType}}</p> -->
                <p class="car-info" >{{todaysBookings.bookingId}}</p>
              <div class="location-info">
                <span class="showAddress"  matTooltip="{{bookingSource?.address}}" matTooltipClass="booking-table-tooltip">
                  {{bookingSource && bookingSource?.address}}
                </span>
                <div class="stops">
                  <span style="font-size: 10px;" *ngIf="todaysBookings.stops.length-2"> +{{todaysBookings.stops.length-2}} stops</span>
                  <img src="/assets/images/arrow-right.svg" alt="openBookingDetailSidebar" [style]="{'margin-bottom':todaysBookings.stops.length-2?'20px':'0px'}"/>
                </div>
                <span  class="showAddress"  matTooltip=" {{bookingDestination?.address}}" matTooltipClass="booking-table-tooltip">
                  {{bookingDestination && bookingDestination?.address}}
                </span>
              </div>
              <p class="car-info" style="font-size: 14px;" *ngIf="todaysBookings?.cab">{{bookings[0]?.cab?.registration}} / {{todaysBookings?.vehicleMake
                || todaysBookings?.vehicleType}}</p>
            </div>
            <div>
              <span mis-input-icon class="chevron-right-circle" (click)="openDrawer(todaysBookings)"><img
                  src="/assets/images/arrow-right-circle.svg" alt="" /></span>
            </div>
          </div>
          <div class="action-container">
            <div class="displayFlex align-item-center" style="gap:8px">
              <div class="marshall-status" *ngIf="todaysBookings.guardReq" style="height: 32px;width: 32px; align-items: center;">
                <img   [src]="checkIfMarshalAssigned(todaysBookings)"  width="24px" height="24px"/>
              </div>
              <img *ngIf="todaysBookings.guardReq" src="/assets/images/booking-card-division.svg" alt="">
              <div style="display: flex;align-items: center;">
                <div class="other-status" style="height: 32px;" [style]="{'background-color':otherState.backGround, 'color':otherState.color}">
                  <img [src]="otherState.url" alt="">
                  <span class="font-weight-700">{{otherState.text}}</span>
                </div>
              </div>
            </div>
            <button  [ngClass]="bookings[0].cab?.registration ? 'btn-track': 'disableTrack' " mis-button type="primary" size="lg" (click)="openTracking()">
              <span mis-input-icon class="track-icon"><img src="/assets/trackWhite.svg" alt="" /></span>
              Track
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="upcoming-container">
    <div class="header">
      <!-- <button mis-button type="none" size="sm" *ngIf="upcomingOnly" class="btn-view-more" (click)="goBack()">
        <span mis-input-icon class="add-icon"><img src="/assets/images/fix-geoback-arrow-left-24.svg" alt="" /></span>
      </button> -->
      <!-- <button mat-icon-button > -->
      <mat-icon (click)="goBack()" *ngIf="upcomingOnly" class="back-icon" svgIcon="back"></mat-icon>
      <!-- </button> -->
      <span class="header-title">{{bookingLabel}}</span>
    </div>
    <div class="no-upcoming-booking" *ngIf="filteredBookings?.length ===0 && bookingLabel === 'Upcoming Booking'">
      <span class="no-upcoming-booking-text fs-14">No Upcoming Booking</span>
    </div>
    <mat-card class="upcoming-booking-card"
      *ngIf="(filteredBookings?.length > 0 && bookingLabel === 'Upcoming Booking') || (bookings?.length && bookingLabel !== 'Upcoming Booking')">
      <div class="schedule-item"
        *ngFor="let booking of filteredBookings | paginate: { itemsPerPage: currentPageSize, currentPage: pageIndexNew, totalItems: totalNoOfRows, id: paginationId }">
        <span class="trip-text">{{booking.spotBookingType}}</span>
        <span class="date-text">{{getBookingDate(booking.startTime.split(' ')[0])}}</span>
        <span class="time-text">{{getBookingTime(booking)}}</span>
        <span mis-input-icon class="chevron-right-icon" (click)="openDrawer(booking)"><img
            src="/assets/images/navigation-chevron-right.svg" alt=""  style="height: 24px; width: 24px;"/></span>
      </div>
    </mat-card>
    <div class="action-container" *ngIf="upcomingBookings?.length > 5 && !upcomingOnly">
      <button mis-button type="none" size="sm" class="btn-view-more" (click)="viewMore()">
        <span mis-input-icon class="add-icon"><img src="/assets/images/add-24.svg" alt="" /></span>
        View More
      </button>
    </div>
  </div>
</div>
<div class="upcoming-main-container" *ngIf="tabValue === 'past'">
  <div class="upcoming-container">
    <div class="header">
      <span class="header-title">Past Bookings</span>
    </div>
    <span class="no-past-booking-text" *ngIf="filteredBookings.length===0">You have no past Bookings</span>
    <mat-card class="upcoming-booking-card" *ngIf="filteredBookings.length>0">
      <!-- let item of [1,2,3,4,5,6,7,8,9,10] -->
      <!-- paginatin => {{currentPageSize}} {{pageIndexNew}} {{bookings?.length}} -->
      <div class="schedule-item"
        *ngFor="let booking of filteredBookings | paginate: { itemsPerPage: currentPageSize, currentPage: pageIndexNew, totalItems: totalNoOfRows, id: paginationId  }">
        <!-- <div class="schedule-item" *ngFor="let booking of bookings"> -->
        <span class="trip-text-grey">{{booking.spotBookingType}}</span>
        <span *ngIf="booking.paymentStatus
        ==='PAID'" class="payment-status-icon" matTooltipClass="tooltip" matTooltip="Payment Successful"
          matTooltipPosition='right'>
          <img src="assets/tick-circle-filled.svg" /> </span>

        <span *ngIf="booking.paymentStatus
        ==='NOT_REQUIRED_FOR_NOW'" class="payment-status-icon" matTooltipClass="tooltip" matTooltip="N/A"
          matTooltipPosition='right'>
          <img src="assets/images/ic-nre-deactivate-24.svg" /> </span>


        <span *ngIf="booking.paymentStatus
        ==='FAILED'" class="payment-status-icon" matTooltipClass="tooltip" matTooltip="Payment Failed"
          matTooltipPosition='right'>
          <img src="assets/ic-ui-cross-24.svg" /> </span>

          <span *ngIf="booking.paymentStatus
          ==='PENDING'" class="payment-status-icon" matTooltipClass="tooltip" matTooltip="Payment Due"
            matTooltipPosition='right'>
            <img src="assets/ic-ui-warning-24.svg" /> </span>


        <span class="date-text">{{getBookingDate(booking.startTime.split(' ')[0])}}</span>
        <span class="time-text">{{getBookingTime(booking)}}</span>
        <span mis-input-icon class="chevron-right-icon" (click)="openDrawer(booking)"><img
            src="/assets/images/navigation-chevron-right.svg" alt="" /></span>
      </div>
    </mat-card>
  </div>
  <div class="past-container">
    <!-- <button class="clear-due-btn"  (click)="openPaymentDrawer(booking)">Clear all Dues</button> -->
  </div>
</div>
<!-- <div>
          <div class="pagination-container">
              <div class="showing"> Showing </div>
          <div class="showing-per-page">
            
            <mat-select
              [value]="1"
              (valueChange)="pageIndex = $event; showNumberOfRecords(pageIndex)"
              style="width: 50px; margin-left: 15px"
            >
              <mat-option *ngFor="let val of tableSizes" [value]="val">{{val}}</mat-option>
      
              
            </mat-select>
      
          </div>
      
          <div style="margin-left: 30px;width: 100%;">Entries of 50 Items</div>
          <div class="pagination-controls">
            <pagination-controls
              (pageChange)="p = $event; paginate(p)"
              previousLabel=""
              nextLabel=""
              [directionLinks]="true"
              class="my-pagination"
            ></pagination-controls>
          </div>
          </div>
      </div> -->

<!-- <div class="booking-item">
  <div class="header">
    <div class="header-item">
      <label class="header-item-label mb-10">Booking ID</label>
      <span class="header-item-text booking-id ellipsis" title={{booking.bookingId}}>{{booking.bookingId}}</span>
    </div>
    <div class="header-item">
      <label class="header-item-label mb-10">Date</label>
      <span class="header-item-text">{{booking.startTime.split(' ')[0]}}</span>
    </div>
    <div class="header-item">
      <label class="header-item-label mb-10">Cab Details</label>
      <span class="header-item-text"
        *ngIf="booking.cab">{{booking.cab.registration}}//{{booking.vehicleMake || booking.vehicleType}}</span>
      <span class="header-item-text" *ngIf="!booking.cab">Not assigned</span>
    </div>
    <div class="header-item">
      <label class="header-item-label mb-10">Driver details</label>
      <span class="header-item-text"
        *ngIf="booking.cab && booking.cab.driver">{{booking.cab.driver.name}}//{{booking.cab.driver.phoneNumbers && booking.cab.driver.phoneNumbers[0]}}</span>
      <span class="header-item-text" *ngIf="!booking.cab || !booking.cab.driver">Not assigned</span>
    </div>
    <div class="header-item right-aligned">
      <app-button title="View History" class="mr-10" class="history-view" type="icon" (click)="handleShowHistoryView()"
        prefixIconSrc=""></app-button>
      <app-button title="Detailed Booking View" class="booking-details-view" type="icon" prefixIconSrc=""
        (click)="handleShowBookingDetails()"></app-button>
    </div>
  </div>
  <div class="content">
    <div class="section-1">
      <div class="action-item" *ngIf="config.Track">
        <app-button type="primaryText" [disabled]="disableAllActions" size="tiny" [text]="getConfigForElement('Track')"
          prefixIconSrc="assets/track-circle-filled.svg" (clickCallback)="toggleTracking()"></app-button>
      </div>
      <div class="action-item" *ngIf="config.Edit">
        <app-button type="primaryText" [disabled]="!canEdit || disableAllActions" size="tiny"
          [text]="getConfigForElement('Edit')" (clickCallback)="handleEditBooking()"
          prefixIconSrc="assets/edit-circle-filled.svg"></app-button>
      </div>
      <div class="action-item" *ngIf="config.Duplicate">
        <app-button type="primaryText" size="tiny" [text]="getConfigForElement('Duplicate')"
          (clickCallback)="handleDuplicateBooking()" prefixIconSrc="assets/duplicate-circle-filled.svg"></app-button>
      </div>
      <div class="action-item" *ngIf="config.Cancel">
        <app-button type="primaryText" [text]="getConfigForElement('Cancel')"
          [disabled]="!canCancel || disableAllActions" (clickCallback)="handleCancelBooking()" size="tiny"
          prefixIconSrc="assets/cancel-circle-filled.svg"></app-button>
      </div>
      <div class="action-item" *ngIf="config.viewDocument">
        <app-button type="primaryText" [text]="getConfigForElement('viewDocument')"
          [disabled]="booking.invoiceApprStatus !== 'APPROVED'" (clickCallback)="viewDocument()" size="tiny"
          prefixIconSrc="assets/invoice.svg"></app-button>
      </div>
    </div>
    <div class="section-2">
      <div class="subsection-1">
        <div class="section-2-item">
          <div class="content-item-header">Cab Type</div>
          <div class="details ellipsis">{{booking.vehicleType || '--'}}</div>
        </div>
        <div class="section-2-item">
          <div class="content-item-header">Booking Type</div>
          <div class="details ellipsis">{{booking.spotBookingType || '--'}}</div>
        </div>
      </div>
      <div class="subsection-2">
        <div class="section-2-item">
          <div class="content-item-header">City</div>
          <div class="details ellipsis">{{booking.city || '--'}}</div>
        </div>
        <div class="section-2-item">
          <div class="content-item-header">Vendor</div>
          <div class="details ellipsis">{{booking.vendor ? booking.vendor.vendorName : 'Not assigned'}}</div>
        </div>
      </div>
    </div>
    <div class="section-3">
      <div class="route-path">
        <div class="route-patch-circle">
          <div class="inner-circle"></div>
          <span class="stop-info">Start</span>
          <div class="source">
            <div class="booking-time">{{startTime}}</div>
            <div class="source-address">
              {{bookingSource && bookingSource.address}}
              {{bookingSource && bookingSource.geoArea}}
            </div>
          </div>
        </div>
        <div class="route-patch-circle stops" *ngIf="noOfStops > 2">
          <span class="stop-info">
            {{noOfStops > 2 ? noOfStops - 2 : '0'}} stop(s)
          </span>
        </div>
        <div class="route-patch-circle right">
          <div class="inner-circle"></div>
          <span class="stop-info">End</span>
          <div class="destination">
            {{bookingDestination && bookingDestination.address}}
            {{bookingDestination && bookingDestination.geoArea}}
          </div>
        </div>
      </div>
    </div>
    <div class="section-4">
      <div class="content-item-header">Riders</div>
      <div class="riders-list mt-10" *ngFor="let rider of this.ridersList">
        <div class="riders-item">{{rider.name}}({{rider.mobile}})</div>
      </div>
    </div>
  </div>
  <div class="footer flex-end"> -->
<!-- <div class="left">
      <span class="request-id" (click)="handleShowRequestDetails()">REQUEST ID {{booking.requestId}}</span>
    </div> -->
<!--  <div class="align-center flex">
      <div *ngIf="booking.paymentStatus !== 'PROCESSING'" class="status pending"
        [ngClass]="{'cancelled': booking.bookingStatus === 'CANCELLED', 'approved': booking.bookingStatus === 'ACTIVE'}">
        {{booking.bookingStatus}}
      </div>
      <div class="payment-status"
        *ngIf="paymentAmount && booking.paymentStatus === 'PROCESSING' && config['Payment Status']">
        <span class="text">Processing</span>
        <img src="assets/Group 10899.svg" />
        <span class="amount">{{paymentAmount}}</span>
      </div>
      <div class="payment-status" *ngIf="paymentAmount && booking.paymentStatus === 'PAID' && config['Payment Status']">
        <span class="text">Paid</span>
        <img src="assets/tick-circle-filled.svg" />
        <span class="amount">{{paymentAmount}}</span>
      </div>
      <app-payment-button *ngIf="checkPayButtonVisibility()" [booking]="booking"
        (paymentSuccessCallback)="paymentSuccess($event)" (paymentFailedCallback)="paymentFailed($event)">
      </app-payment-button>
    </div>
  </div> -->
<app-cab-track *ngIf="isTrackingVisible" (closeCallback)="toggleTracking()" [booking]="bookings[0]"></app-cab-track>
<app-dialog *ngIf="showCancelBookingError" (approveCallback)="hideCancelBookingError()" type="alert"
  [buttonText]="['Okay']">
  Cancellation cutoff passed. For any assistance, please contact your transport team.
</app-dialog>
<app-dialog *ngIf="showEditBookingError" (approveCallback)="hideEditBookingError()" type="alert" [buttonText]="['Okay']">
  Edit cutoff passed. For any assistance, please contact your transport team.
</app-dialog>
<app-toast *ngIf="showSuccessMessage" message="Your payment is being processed" (dismissCallback)="toggleToast()">
</app-toast>
<app-dialog *ngIf="showPaymentFailed" titleText="Payment Error" (approveCallback)="hidePaymentError()" type="alert"
  [buttonText]="['Okay']">
  {{paymentFailedMessage}}
</app-dialog>


<app-popover *ngIf="showBulkPaymentPopup || showSinglePaymentPopup" (closeCallback)="closePaymentPopup()" size="small" >
  <div popover-content class="payment-msg-container" *ngIf="paymentResponse=='Success'; else paymentFail">
    <div class="payment-img">
      <img class="success-img" src="assets/tick-circle-filled.svg">
    </div>
    <div class="payment-msg">
      Payment Successful
    </div>
    <div class="amt-paid" *ngIf="showSinglePaymentPopup; else bulk">
      Paid ₹ {{paymentAmt}}
    </div>
    <ng-template #bulk>
      <div class="amt-paid">
      Amount paid ₹ {{totalAmt}}
    </div>
    </ng-template>
    <span class="transactionId">
      Transaction ID: {{razorpay_payment_id}}
    </span>
  </div>
  <ng-template popover-content #paymentFail>
    <div class="payment-img ">matTooltip="Payment Successful"
      <img class="success-img" src="assets/ic-ui-error-24.svg">
    </div>
    <div class="payment-msg payment-msg-container">
      Payment Unsuccessful
    </div>
    <div class="amt-paid">
      If your money has been debited it will be refunded within 3-5 business days.
    </div>
    <span class="transactionId">
      Transaction ID: {{razorpay_payment_id}}
    </span>
   
  </ng-template>
  <div popover-actions class="okay-btn">
    <app-button type="primaryFilled" text="Okay" (clickCallback)="closePaymentPopup()"></app-button>
  </div>

</app-popover>
<span *ngIf="showSnackbar" class="snackbar">You are being redirected to Razorpay’s Payment Gateway</span>

